import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

const FormSection = ({
  children,
  className,
  title,
  show
}) => {
  if (!show) {
    return null
  }
  return (
    <section className={classNames('field-group', className, { show })}>
      <h2>{title}</h2>
      {children}
    </section>
  )
}

FormSection.propTypes = {
  children: PropTypes.node,
  show: PropTypes.bool,
  title: PropTypes.string
}

export { FormSection as default }



// WEBPACK FOOTER //
// ./src/shared/components/FormSection.js